<template>
    <div class="container justify-content-center d-flex" @mouseleave="closeDropdown">
        <div :class="['menuItem', {'selected': mainItem == 1}]" @mouseenter="openDropdown(1)">
            <i class="icon icon-blago"></i><br>
            Stoffe
        </div>
        <a href="/kategorie/naehzubehoer-und-zubehoer" :class="['menuItem', {'selected': mainItem == 2}]" @mouseenter="openDropdown(2)">
            <i class="icon icon-dodatki"></i><br>
            Zubehör
        </a>
        <div :class="['menuItem', {'selected': mainItem == 3}]" @mouseenter="openDropdown(3)">
            <i class="icon icon-pletenje"></i><br>
            Stricken & Sticken
        </div>
        <a href="/kategorie/diy" :class="['menuItem', {'selected': mainItem == 6}]" @mouseenter="openDropdown(6)">
            <img src="/images/Naredi-si.svg" alt="DIY" style="width: 70px; margin-top: 5px; margin-bottom: 19px;"><br>
            DIY
        </a>
        <a href="/blog" class="menuItem" @mouseenter="closeDropdown">
            <i class="icon icon-blog-1"></i><br>
            Blog
        </a>
        <div :class="['menuItem', {'selected': mainItem == 4}]" @mouseenter="openDropdown(4)">
            <i class="icon icon-popusti"></i><br>
            Rabatte
        </div>
<div :class="['dropdownContainer', {'d-block': dropDownOpened}]">
            <div class="menuContainer">
                <div class="row">
                    <div class="col">
                        <a :href="item.nice_url" v-for="item in mainItemsArray" :class="['mainItem', {'selected': subItem == item.id}]" :key="item.id" @mouseover="loadSubItems(item.id)">{{ item.title}}</a>
                    </div>
                    <div class="col">
                        <a :href="item.nice_url" v-for="item in subItemsArray[1]" :key="item.id">{{ item.title }}</a>
                    </div>
                    <div class="col">
                        <a :href="item.nice_url" v-for="item in subItemsArray[2]" :key="item.id">{{ item.title }}</a>
                    </div>
                    <div class="col">
                        <a :href="item.nice_url" v-for="item in subItemsArray[3]" :key="item.id">{{ item.title }}</a>
                    </div>
                    <div class="col">
                        <a :href="item.nice_url" v-for="item in subItemsArray[4]" :key="item.id">{{ item.title }}</a>
                    </div>
                    <div class="col">
                        <a :href="item.nice_url" v-for="item in subItemsArray[5]" :key="item.id">{{ item.title }}</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Request from '@Core/xhr'

export default {
    data () {
        return {
            mainItem: 0,
            subItem: 0,
            dropDownOpened: false,
            mainItemsArray: [],
            subItemsArray: [],
            cacheSubItems: []
        }
    },

    methods: {
        openDropdown (item) {
            let request = new Request({ top_category: item })
            request.post('/header/primary_categories').then((response) => {
                this.mainItemsArray = response;
                this.mainItem = item;
                this. dropDownOpened = true;
                this.subItemsArray = [];
                this.subItem = 0;
                this.loadSubItems(this.mainItemsArray[0]['id'])
            });
        },

        closeDropdown () {
            this.mainItem = 0;
            this. dropDownOpened = false;
            this.subItemsArray = [];
            this.subItem = 0;
        },

        loadSubItems(item) {
            let request = new Request({ category_id: item })
            if(item in this.cacheSubItems) {
                this.subItemsArray = this.cacheSubItems[item];
            } else {
                request.post('/header/sub_categories').then((response) => {
                    this.subItemsArray = response;
                    this.cacheSubItems[item] = response;
                });
            }

            this.subItem = item;
        }
    }
}
</script>
